import { Box, Flex, Heading, HStack, Image, Stack, Text } from "@chakra-ui/react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { LuArrowLeft, LuHouse, LuSearchX } from "react-icons/lu";
import { useI18n } from "src/i18n/I18nContext";


const NotFound = () => {
    const navigate = useNavigate();
    const { t } = useI18n();

    const goBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
            return;
        }
        navigate('/');
    };

    return (
        <Flex
            flex="1"
            align="center"
            justify="center"
            bg="gray.50"
            px={{ base: 4, md: 8, xl: 12 }}
            py={{ base: 8, md: 12 }}
        >
            <Flex
                w="full"
                maxW="6xl"
                direction={{ base: 'column', lg: 'row' }}
                bg="white"
                borderWidth="1px"
                borderColor="gray.200"
                rounded="lg"
                boxShadow="0 24px 70px rgba(15, 23, 42, 0.10)"
                overflow="hidden"
            >
                <Stack
                    flex="1"
                    justify="center"
                    gap={{ base: 6, md: 8 }}
                    minH={{ base: 'auto', lg: '560px' }}
                    px={{ base: 6, sm: 8, md: 12, xl: 14 }}
                    py={{ base: 8, md: 12 }}
                >
                    <HStack gap="3" color="blue.600" fontWeight="semibold">
                        <Flex
                            align="center"
                            justify="center"
                            boxSize="10"
                            bg="blue.50"
                            borderWidth="1px"
                            borderColor="blue.100"
                            rounded="md"
                        >
                            <LuSearchX size={22} />
                        </Flex>
                        <Text>{t('notFound.eyebrow')}</Text>
                    </HStack>

                    <Stack gap="4">
                        <Heading
                            as="h1"
                            fontSize={{ base: '4xl', sm: '5xl', md: '6xl' }}
                            lineHeight="1.03"
                            letterSpacing="0"
                            color="gray.900"
                        >
                            {t('notFound.title')}
                        </Heading>
                        <Text
                            maxW="xl"
                            fontSize={{ base: 'md', md: 'lg' }}
                            color="gray.600"
                        >
                            {t('notFound.description')}
                        </Text>
                    </Stack>

                    <HStack gap="3" flexWrap="wrap">
                        <Button
                            colorPalette="blue"
                            rounded="md"
                            size={{ base: 'md', md: 'lg' }}
                            onClick={() => navigate('/')}
                        >
                            <LuHouse />
                            {t('notFound.home')}
                        </Button>
                        <Button
                            variant="outline"
                            color="gray.700"
                            borderColor="gray.300"
                            rounded="md"
                            size={{ base: 'md', md: 'lg' }}
                            onClick={goBack}
                            _hover={{ bg: 'gray.50', borderColor: 'gray.400' }}
                        >
                            <LuArrowLeft />
                            {t('notFound.back')}
                        </Button>
                    </HStack>
                </Stack>

                <Box
                    flex="1"
                    position="relative"
                    minH={{ base: '270px', sm: '330px', lg: 'auto' }}
                    bg="gray.900"
                >
                    <Image
                        alt={t('notFound.imageAlt')}
                        src={'/images/desert.webp'}
                        w="full"
                        h="full"
                        objectFit="cover"
                        objectPosition="center"
                    />
                    <Box
                        position="absolute"
                        inset="0"
                        bg="linear-gradient(180deg, rgba(17, 24, 39, 0.02) 0%, rgba(17, 24, 39, 0.70) 100%)"
                    />
                    <Stack
                        position="absolute"
                        left={{ base: 5, md: 8 }}
                        right={{ base: 5, md: 8 }}
                        bottom={{ base: 5, md: 8 }}
                        gap="2"
                        color="white"
                    >
                        <Text
                            fontSize={{ base: '5xl', md: '7xl', lg: '8xl' }}
                            fontWeight="bold"
                            lineHeight="0.9"
                            letterSpacing="0"
                        >
                            404
                        </Text>
                        <Text
                            maxW="sm"
                            color="whiteAlpha.900"
                            fontSize={{ base: 'sm', md: 'md' }}
                        >
                            {t('notFound.imageCaption')}
                        </Text>
                    </Stack>
                </Box>
            </Flex>
        </Flex>
    );
}

export default NotFound;
